import api from "../apiapp";

const ExchangeOperationService = {

  setOperations: async function (model) {
    const response = await api.request({
      url: 'exchange-operations',
      method: "POST",
      data: model
    })
    
    return response.data
  },
  getOperationsDay: async function () {
    const response = await api.request({
      url: 'exchange-operations/reports/today?sort=-date&include=accountModel,user,settlementTerm,operationType,currency,market,segment,priceType,operationState,counterparty,currencyExchangeType,blockedBy',  
      method: "GET",
    })
  
    return response.data
  },
  putOperationsStatus: async function (id, status) {
    const response = await api.request({
      url: 'exchange-operations/'+id+'/change-state',
      method: "PUT",
      data: {operation_state_id: status}
    })
  
    return response.data
  },
  getOperationSearch: async function (model) {
    var filters = '';
		if(model.dateFrom !== '' && model.dateFrom !==""){ filters += '&filter[from]='+model.dateFrom; }
		if(model.dateTo !== '' && model.dateTo !== ""){ filters += '&filter[to]='+model.dateTo; }
		if(model.account !== '' && model.account !== null){ filters += '&filter[account]='+model.account; }
		if(model.manager !== '' && model.manager !== null){ filters += '&filter[portfolioManagerId]='+model.manager; }
		if(model.status !== '' && model.status !== null){ filters += '&filter[state]='+model.status; }
    if(model.currency !== '' && model.currency !== null){ filters += '&filter[currency]='+model.currency; }
    const response = await api.request({
      url: 'exchange-operations?sort=-date&page[size]=100&&include=user,operationLogs,settlementTerm,operationType,currency,market,segment,operationState,accountModel,blockedBy,portfolioManager,counterparty,currencyExchangeType,exchangeOperationLog'+filters,
      method: "GET",
    })
  
    return response.data
  },
  getOperationsSearchPagination: async function (url) {
    const response = await api.request({
      url: url,
      method: "GET",
    })
  
    return response.data
  },
  postOperationsSavePrice: async function (id, price) {
    const response = await api.request({
      url: 'exchange-operations/'+id+'/change-esco-price',
      method: "POST",
      data: {}
    })
  
    return response.data
  },
  putOperationsPrice: async function (id, model) {
    const response = await api.request({
      url: 'exchange-operations/'+id+'/change-price',
      method: "PUT",
      data: model
    })
  
    return response.data
  },
  getBalanceByPorfolio: async function (date) {
    const response = await api.request({
      // url: 'exchange-operations/reports/balance?sort=-date&page[size]=100&filter[settlementTerm]=1',
      url: 'exchange-operations/reports/balance/by-portfolio-manager?page[size]=100&date='+date,
      method: "GET",
    })
  
    return response.data
  },
  getBalanceByCounterparty: async function (date) {
    const response = await api.request({
      url: 'exchange-operations/reports/balance/by-counterparty?page[size]=100&date='+date,
      method: "GET",
    })
  
    return response.data
  },
  setBalanceDownload: async function (model) {
    const response = await api.request({
      url: 'exchange-operations/download/excel/by-ids',
      method: "POST",
      data: model
    })
  
    return response.data
  },
  deleteIntermOperation: async function (id) {
    const response = await api.request({
      url: 'exchange-operations/'+id,
      method: "DELETE",
    })
  
    return response.data
  },
  getHomeInformation: async function (date, dateTo) {
    const response = await api.request({
      // url: 'exchange-operations/reports/spreads?date='+date,
      url: 'exchange-operations/reports/spreads?from='+date+'&to='+dateTo,
      method: "GET",
    })
  
    return response.data
  },
  getIntermOperationByIds: async function (ids) {
    const response = await api.request({
      url: 'exchange-operations/by-ids?ids='+ids+'&include=counterparty,currency,currencyExchangeType,operationType,operationState,settlementTerm,market,segment,priceType,accountModel,user,portfolioManager',
      method: "GET",
    })
  
    return response.data
  },
  

}

export default ExchangeOperationService;